export default "__VITE_ASSET__Bx5G3Cph__"